import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function AdminRoute({ children }) {
  const token = typeof window !== 'undefined' && localStorage.getItem('psf_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return children || <Outlet />;
}
